import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { parametrosApi } from './api';
import type { ParametroSistemaDto, ParametroSistemaInput } from './types';

const KEY = ['parametros'] as const;

export function useParametrosQuery(): UseQueryResult<ParametroSistemaDto, Error> {
  return useQuery({
    queryKey: [...KEY, 'singleton'],
    queryFn: () => parametrosApi.get(),
  });
}

export function useParametrosMutation(): UseMutationResult<
  ParametroSistemaDto,
  Error,
  ParametroSistemaInput
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ParametroSistemaInput) => parametrosApi.update(input),
    onSuccess: (data) => {
      qc.setQueryData([...KEY, 'singleton'], data);
    },
  });
}
